export function hasMsalRedirectInUrl() {
  const hash = window.location.hash || "";
  const search = window.location.search || "";
  const combined = `${hash}${search}`;
  return (
    /(?:^|[#&?])code=/.test(combined) ||
    /(?:^|[#&?])error=/.test(combined) ||
    /(?:^|[#&?])state=/.test(combined)
  );
}
